<h2 mat-dialog-title class="modal-add-header">{{ _e.siteDetailEditLogoHeader }}</h2>
<form [formGroup]="fg" (ngSubmit)="onSubmit()">
    <mat-dialog-content>
      <mat-form-field>
        <mat-label>เลือกไฟล์รูปภาพ</mat-label>
        <input matInput readonly="true" placeholder="เลือกไฟล์รูปภาพ" formControlName="displayLogoName" (click)="fileUpload.click()">
        <mat-hint>{{_e.addHospitalHintLogo}}</mat-hint>
        <mat-error *ngIf="fg.get('displayLogoName').getError('size')">{{_e.addHospitalLogoBigger}}</mat-error>
        <mat-error *ngIf="fg.get('displayLogoName').getError('required')">{{ _e.siteDetailEditLogoRequiredName }}</mat-error>
        <!-- <input matInput readonly="true" value="* upload file more than 200k" *ngIf="fileSizeError" style="color:red"> -->
      </mat-form-field>
      <button type="button" class="browseButton" mat-raised-button (click)="fileUpload.click()">เลือกรูปภาพ</button>
      
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="flex-spacer"></div>
      <button type="button" mat-raised-button mat-dialog-close [mat-dialog-close]="false">ยกเลิก</button>
      <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
      <button type="button" mat-raised-button class="submit-button" (click)="onSubmit()">บันทึก</button>
    </mat-dialog-actions>
  </form>
  <input type="file" readonly="true" placeholder="เลือกไฟล์รูปภาพ" accept="image/*" (change)="onFileChange($event)" #fileUpload style="display:none">



<!-- <div>
    <h2 mat-dialog-title>{{ header }}</h2>
    <mat-dialog-content>
        <mat-label>เลือกไฟล์รูปภาพ</mat-label>
        <input matInput readonly="true" placeholder="เลือกไฟล์รูปภาพ" (click)="fileUpload.click()">
        <mat-hint>{{hintMessage}}</mat-hint>
        <mat-error >{{errBiggerSizeMessage}}</mat-error>
        <button type="button" class="browseButton" mat-raised-button (click)="fileUpload.click()">เลือกรูปภาพ</button>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="flex-spacer"></div>
      <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
      <button mat-raised-button class="submit-button" (click)="onYesClick()">บันทึก</button>
    </mat-dialog-actions>
  </div>
  <input type="file" readonly="true" placeholder="เลือกไฟล์รูปภาพ" accept="image/*" (change)="onFileChange($event)" #fileUpload style="display:none"> -->

